import React, { useRef, useState } from "react";
import { Box, Button, styled, Typography } from "@mui/material";
import emailjs from "@emailjs/browser";
import { schema } from "./FormValidation";
import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';
import {HashLink as Link } from 'react-router-hash-link';


const Wrapper = styled(Box)`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Component = styled(Box)`
  display: flex;
  flex-direction: column;
  margin: 10px;
  font-family:'Lora', serif;
`;

const Input = styled("input")({
  borderRadius: "15px",
  background: "#E2E8F4",
  borderStyle: "none",
  fontSize: "15px",
  outline: "none",
});

const ContactForm = () => {
  const form = useRef();

  const [Name, setName] = useState();
  const [Email, setEmail] = useState();
  const [Message, setMessage] = useState();
  const [valid, setValid] = useState("");
  const [state, setState] = useState(false);

  const formData = { name: Name, email: Email, message: Message };

  const createUser = async (e) => {
    console.log(formData);
    const isValid = await schema.isValid(formData);
    setValid(isValid);
    sendEmail(e, isValid);
    setState(true);
  };

  const sendEmail = (e, isValid) => {
    e.preventDefault();
    if (isValid) {
      emailjs
        .sendForm(
          "service_1q9hvto",
          "template_zriq4zi",
          form.current,
          "mh7ILzzC9jFxbDxxy"
        )
        .then(
          (result) => {
            console.log(result);
          },
          (error) => {
            console.log(error.text);
          }
        );
    } else {
      console.log("wrong input");
    }
  };

  setTimeout(() => {
    setState(false);
  }, 5000);

  return (
    <Box>
    <Wrapper id="Contact">
      <form ref={form} onSubmit={createUser} style={{ width: "50%" }}>
        <Box
          component="h1"
          style={{
            margin: "50px 0px",
            textAlign: "center",
            color: "#010B30",
          }}
        >
          Contact Me
        </Box>
        <Component>
          <span>NAME</span>
          <Input
            type="text"
            value={Name}
            style={{ padding: "15px", marginTop: "5px" }}
            name="name"
            onChange={(e) => setName(e.target.value)}
          />
        </Component>
        <Component>
          <span>EMAIL</span>
          <Input
            type="email"
            value={Email}
            style={{ padding: "15px", marginTop: "5px" }}
            name="email"
            onChange={(e) => setEmail(e.target.value)}
          />
        </Component>
        <Component>
          <span>MESSAGE</span>
          <textarea
            name="message"
            value={Message}
            onChange={(e) => setMessage(e.target.value)}
            style={{
              height: "280px",
              borderRadius: "15px",
              background: "#E2E8F4",
              borderStyle: "none",
              outline: "none",
              fontSize: "15px",
              padding: "15px",
              marginTop: "5px",
            }}
          />
        </Component>
        {state &&
          (valid ? (
            <Typography
              style={{
                marginLeft: "15px",
                color: "slateblue",
                fontSize: "21px",
                fontFamily: "cursive",
              }}
            >
              Email sent successfully
            </Typography>
          ) : (
            <Typography
              style={{
                marginLeft: "15px",
                color: "slateblue",
                fontSize: "21px",
                fontFamily: "cursive",
              }}
            >
              Enter Correct Details or increase length of message
            </Typography>
          ))}
        <Box style={{ width: "100%", textAlign: "center", margin: "30px 0px" }}>
          <Button
            variant="contained"
            style={{ width: "95%" }}
            onClick={createUser}
          >
            SEND MESSAGE
          </Button>
        </Box>
      </form>
      </Wrapper>
    <Box style={{textAlign:'center'}}>
      <Link to ='#Home' smooth>
    <ArrowCircleUpIcon style={{fontSize:'40px'}}/>
    <Typography style={{fontFamily:'cursive'}}>Move to top</Typography>
    </Link>
  </Box>
  </Box>
  );
};

export default ContactForm;
